module.exports = __webpack_public_path__ + "img/banner04_info_pic.96f22390.jpg";